// removed by extract-text-webpack-plugin
module.exports = {"root":"_3ZO33","logo":"_1Q-Kt","expander":"_1Sg6y","pinned":"_1w-9I","online":"_2ZqAF","inverted":"_3SqYL","unfixed":"_1jp8o"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Default/Header/Header.sass
// module id = ./src/layouts/Default/Header/Header.sass
// module chunks = 6